export default __webpack_public_path__ + "static/media/notice-orange.f20b7718.svg";